import React from 'react'

export const SideBarHelpMe: React.FC<{
  className?: string
  titleClas?: string
}> = ({ className, titleClas }) => {
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className="flex flex-col gap-2">
        <p className={`font-fira text-lg ${titleClas}`}>Precisa de Ajuda?</p>
        <p className="font-fira text-sm text-gray-700">
          Entre em contato conosco pelo número: <br />
        </p>
        <p className="font-bold text-sm text-gray-700">+55 (99) 9999-9999</p>
      </div>
    </div>
  )
}
